import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  return <section className="about" data-id="element-12">
      <motion.div className="about-inner" initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-40px'
    }} transition={{
      duration: 0.8
    }} data-id="element-13">
        <span className="section-tag" data-id="element-14">Tu Instructora</span>
        <h2 data-id="element-15">Sharon Tirado</h2>
        <p data-id="element-16">
          Fundadora de <strong data-id="element-17">Infinia</strong>, agencia de generación de leads
          y ventas con Meta Ads. Ha ayudado a negocios a escalar de 6 a 7 cifras
          con marketing digital. Más de{' '}
          <strong data-id="element-18">70,000 seguidores en Instagram</strong>. Este no es un
          workshop teórico — es el mismo proceso que usa para crear páginas para
          sus clientes y sus propios proyectos.
        </p>
      </motion.div>
    </section>;
}